import React, { useState, useEffect } from "react";
import {
  Tooltip,
  PieChart,
  Pie,
  Cell,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { FaSquareFull } from "react-icons/fa";
const PieCharts = ({ data, DataKey, data768, data576, data992, data1400, irr, orr }) => {
  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "red"];
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  });
  let asp;
  let ir;
  let or;
  if (windowWidth <= 364) {
    // console.log("window dimensions", windowWidth);
    asp = 1.9;
    ir = 55;
    or = 75;
  } else if (windowWidth <= 576 && windowWidth > 364) {
    // console.log("Window diemensions", windowWidth);
    asp = 1.9;
    ir = 60;
    or = 80;
  } else if (windowWidth > 576 && windowWidth < 768) {
    // console.log(windowWidth);
    asp = data576 ? data576 : 2;
    ir = 70;
    or = 90;
  } else if (windowWidth >= 768 && windowWidth < 992) {
    // console.log(windowWidth);
    asp = data768 ? data768 : 1.1;
    ir = irr ? irr : 80;
    or = orr ? orr : 100;
  } else if (windowWidth >= 992 && windowWidth < 1400) {
    // console.log(windowWidth);
    asp = data992 ? data992 : 1;
    ir = irr ? irr : 80;
    or = orr ? orr : 100;
  }
  else if (windowWidth >= 1400 && windowWidth < 2400) {
    asp = 2;
    ir = 90;
    or = 120;
  }
  else {
    // console.log(windowWidth);
    asp = data1400 ? data1400 : 1;
    ir = 50;
    or = 70;
  }
  const CustomLegend = props => {
    let { payload } = props;
    return (
      <div className="d-flex flex-md-wrap align-items-center justify-content-center gap-2" style={{ cursor: "pointer" }}>
        {payload.map((entry, index) => (
          <div key={index} className="d-flex align-items-center gap-1">
            <span>
              <FaSquareFull color={COLORS[index]} size={"17px"} />
            </span>
            <h5 key={index} className="text-muted">{entry.value}</h5>
          </div>
        ))}
      </div>
    )
  }
  return (
 <div
  style={{
    width: "100%",
    height: "300px", // Or whatever height works for your design
    overflow: "visible",
  }}
  className="d-flex align-items-center justify-content-center"
>
  <ResponsiveContainer width="100%" height="100%">
    <PieChart>
      <Pie
        data={data}
        innerRadius={ir}
        outerRadius={or}
        fill="#8884d8"
        paddingAngle={1}
        dataKey={DataKey}
      >
        {data.map((entry, index) => (
          <Cell
            key={`cell-${index}`}
            fill={COLORS[index % COLORS.length]}
          />
        ))}
      </Pie>
      <Legend content={<CustomLegend />} />
      <Tooltip />
    </PieChart>
  </ResponsiveContainer>
</div>

  );
};


export default PieCharts;
